import React from 'react'
import logo from '../../assets/images/logo.jpg'

export default function Navbar() {
  return (
    <div style={{display:'block',padding:'1.5em'}} >
      <img style={{width:'7rem',height:'2.8rem'}} src={logo}/> 
     
     
    </div>
  )
}
